import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router';
import * as FacilitiesActions from '../../actions/facilities_actions';
import * as DashboardActions from '../../actions/dashboard_actions';
import { bindActionCreators } from 'redux';
import { FacilitiesHeader } from './facility-header';
import { FacilitiList } from './facility-list';
import { Addfacility } from './add-facility';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { ModalDialogCommon } from '../modal_dialog_common';
import Header from '../../components/header';
import _ from 'lodash';
import * as api_urls from './../../config/api_urls';
let screenIdentifier = 'facilities';

export var FacilitiesDetails = React.createClass({
    getInitialState() {
        return {
            facilitiListLength: false,
            modal: false, modal_msg: "", edit_mode: null, modal_admin: false, isActivation: false, isDeActivation: false,
            activeStatus: "", fac_id: "",
            activateDeactivateCalled: false,
            resendLinkClicked: false,
            confimationModalMessage: null,
            confirmationType: null,
            confirmationData: null,// data object to send to actions.
        }
    },
    componentWillMount() {
        this.props.FacilitiesDetails.FaciliteAdminUser = {};
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    componentWillReceiveProps(nextProps) {
        this.setState({ loader: false });
        if (nextProps.FacilitiesDetails.FaciliteAdminUser ? nextProps.FacilitiesDetails.FaciliteAdminUser.status == 200 : false) { this.props.router.push('/facilities/admin/edit'); }
        if (this.state.resendLinkClicked) {
            if (nextProps.FacilitiesDetails.ResendLinkStatus) {
                this.setState({ oKModalMessage: nextProps.FacilitiesDetails.ResendLinkStatus.message });
                nextProps.FacilitiesDetails.ResendLinkStatus = null;
            }
            this.setState({ resendLinkClicked: false })
            let faciliti_id = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
            this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(faciliti_id));
        }
        if (this.state.activateDeactivateCalled) {

            if (nextProps.FacilitiesDetails.ActivateAdmin && nextProps.FacilitiesDetails.ActivateAdmin.message) {
                this.setState({ oKModalMessage: nextProps.FacilitiesDetails.ActivateAdmin.message });
                nextProps.FacilitiesDetails.ActivateAdmin = null;
            }

            if (nextProps.FacilitiesDetails.DeactivateAdmin && nextProps.FacilitiesDetails.DeactivateAdmin.message) {
                this.setState({ oKModalMessage: nextProps.FacilitiesDetails.DeactivateAdmin.message });
                nextProps.FacilitiesDetails.DeactivateAdmin = null;
            }

            let faciliti_id = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
            this.setState({ activateDeactivateCalled: false })
            this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(faciliti_id));
            this.props.Dispatch(DashboardActions.notifications());
        }

    },
    componentDidMount() {

    },
    getFacilityDetail() {

        var facility_details = this.props.FacilitiesDetails.FaciliteDetailsByID.data;

        return facility_details;
    },
    getFacilityAdmin(e) {

        var admin_id = e.target.attributes['data-staf-id'].value;
        let f_id = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id
        this.props.Dispatch(FacilitiesActions.getAdminUserById(admin_id + "/" + f_id));

    },
    accept_pending_admin(event) {
        let data = {};
        data.uniqueKey = event.target.dataset.uniquekey;
        data.id = parseInt(event.target.dataset.stafId);
        data.facilityId = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
        data.isDeactive = false; //true ---> true if accept false if reject
        this.props.Dispatch(FacilitiesActions.activate_admin(data));
        this.setState({ activateDeactivateCalled: true });
        this.setState({ loader: true });
    },
    decline_pending_admin(event) {
        let data = {};
        data.uniqueKey = event.target.dataset.uniquekey;
        data.id = parseInt(event.target.dataset.stafId);
        data.facilityId = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
        data.isDeactive = true; //true ---> true if accept false if reject
        this.props.Dispatch(FacilitiesActions.activate_admin(data));
        this.setState({ activateDeactivateCalled: true })
        this.setState({ loader: true });
    },
    accept_deactivation_pending(event) {
        let data = {};
        data.uniqueKey = event.target.dataset.uniquekey;
        data.id = parseInt(event.target.dataset.stafId);
        data.facilityId = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
        data.isDeactive = true; //true ---> true if accept false if reject
        this.props.Dispatch(FacilitiesActions.deactivate_admin(data));
        this.setState({ activateDeactivateCalled: true })
        this.setState({ loader: true });
    },
    decline_deactivation_pending(event) {
        let data = {};
        data.uniqueKey = event.target.dataset.uniquekey;
        data.id = parseInt(event.target.dataset.stafId);
        data.facilityId = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
        data.isDeactive = false; //true ---> true if accept false if reject
        this.props.Dispatch(FacilitiesActions.deactivate_admin(data));
        this.setState({ activateDeactivateCalled: true })
        this.setState({ loader: true });
    },
    activate_admin(event) {
        let data = {};
        data.uniqueKey = event.target.dataset.uniquekey;
        data.id = parseInt(event.target.dataset.stafId);
        data.facilityId = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
        data.isDeactive = false; //true ---> true if accept false if reject
        this.setState({ confirmationType: 'AdminActivation', confirmationData: data, confimationModalMessage: 'Are you sure you want to activate the admin account?', loader: true })
    },
    deactivate_admin(event) {

        let data = {};
        data.uniqueKey = event.target.dataset.uniquekey;
        data.id = parseInt(event.target.dataset.stafId);
        data.facilityId = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
        data.isDeactive = true; //true ---> true if accept false if reject
        this.setState({ confirmationType: 'AdminDeactivation', confirmationData: data, confimationModalMessage: 'Are you sure you want to deactivate the admin account?', loader: true })

    },
    onConfirmed() {

        if (this.state.confirmationType === 'AdminActivation') {
            this.props.Dispatch(FacilitiesActions.activate_admin(this.state.confirmationData));
            this.setState({ activateDeactivateCalled: true })
        }

        if (this.state.confirmationType === 'AdminDeactivation') {
            this.props.Dispatch(FacilitiesActions.deactivate_admin(this.state.confirmationData));
            this.setState({ activateDeactivateCalled: true })
        }

        this.setState({ confirmationType: null, confirmationData: null, confimationModalMessage: null });
    },
    resendLink(event) {
        let facilityId = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
        let id = event.target.attributes['data-staf-id'].value;
        this.props.Dispatch(FacilitiesActions.RequestResendLink(id + "/" + facilityId + "/" + this.props.UserDetails.selectedUserRoleID));
        this.setState({ resendLinkClicked: true })
    },
    generateTabList() {
        var templateAdmin;
        var templateStaf = <tr><td>00001</td><td>Male</td><td>MBBS</td><td>Cardiologist</td><td>Admin</td></tr>;
        var templatePatient = <tr><td>00001</td><td>Male</td><td>MBBS</td><td>Cardiologist</td><td>Admin</td></tr>;
        var _fac_detail = this.getFacilityDetail();
        var admin_arr = [], staff_arr = [], patients = [];
        var admin_info = [], staff_info = [], patients_info = [];
        //(1-super admin,//2-admin,//3-Psychiatrist Support Staff,//4-Therapist,//5-Other Support Staff,
        //6-Administrative Staff,//7-Patient)

        _fac_detail.users.forEach(function (i, k) {

            //switch (i.roleId) {
            switch (i.role.id) {
                case 2:
                    admin_arr.push(i);
                    admin_info.push(i);
                    break;
                case 7:
                    patients.push(i);
                    patients_info.push(i);
                    break;
                case 8:
                    staff_arr.push(i);
                    staff_info.push(i);
                    break;
            }
        });
        let allAdminsCount = admin_arr.length;
        let allStaffCount = staff_arr.length;
        let allPatientsCount = patients.length;
        admin_arr = _.sortBy(admin_arr, 'id');
        var active_admins = _.filter(admin_info, function (item) {
            return item.status == "APPROVE";
        });
        var pendingOrActive_admins = _.filter(admin_info, function (item) {
            return item.status == "APPROVE" || "ACCEPTED";
        });


        var active_staff = _.filter(staff_info, function (item) {
            return item.status == "APPROVE" || "ACCEPTED";
        });
        var active_patients = _.filter(patients_info, function (item) {
            return item.status == "APPROVE" || "ACCEPTED";
        });
        var order_admin = _.orderBy(admin_arr, ['id'], ['desc']);

        templateAdmin = order_admin.map(function (list, key) {

            let template = "";

            switch (list.status) {

                case "PENDING":
                    // do something
                    template = (<tr key={key} className={list.status == "EXPIRED" ? "expired" : ""}><td><span className="email-overflow">{list.user.firstName + " " + list.user.lastName}</span></td><td><span className="email-overflow">{list.user.email}</span></td><td >{list.user.mobile}</td><td><span className="email-overflow">{list.facilityRole && list.facilityRole.name ? list.facilityRole.name : 'NA'}</span></td><td colSpan={2}><button data-staf-id={list.user.id} data-uniqueKey={list.user.uniqueKey} onClick={this.accept_pending_admin} className="activate">Accept Admin</button> <button data-uniqueKey={list.user.uniqueKey} data-staf-id={list.user.id} onClick={this.decline_pending_admin} className="deactivate reject">Reject</button></td></tr>);
                    break;

                case "DEACTIVATEPENDING":
                    template = (<tr key={key} className={list.status == "EXPIRED" ? "expired" : ""}><td><span className="email-overflow">{list.user.firstName + " " + list.user.lastName}</span></td><td><span className="email-overflow">{list.user.email}</span></td><td>{list.user.mobile}</td><td><span className="email-overflow">{list.facilityRole && list.facilityRole.name ? list.facilityRole.name : 'NA'}</span></td><td colSpan={2}> <button data-staf-id={list.user.id} data-uniqueKey={list.user.uniqueKey} onClick={this.accept_deactivation_pending} className="activate">ACCEPT DEACTIVATION</button><button data-uniqueKey={list.user.uniqueKey} data-staf-id={list.user.id} onClick={this.decline_deactivation_pending} className="deactivate reject">Decline</button></td></tr>);
                    // do something
                    break;
                case "EXPIRED":
                    template = (<tr key={key} className={list.status == "EXPIRED" ? "expired" : ""}><td> {list.status == "APPROVE" ? <span className="email-overflow" data-staf-id={list.user.id} onClick={this.getFacilityAdmin}>{list.user.firstName + " " + list.user.lastName}</span> : <span className="email-overflow">{list.user.firstName + " " + list.user.lastName}</span>}</td><td><span className="email-overflow">{list.user.email}</span></td><td>{list.user.mobile}</td><td><span className="email-overflow">{list.facilityRole && list.facilityRole.name ? list.facilityRole.name : 'NA'}</span></td><td></td><td><span data-uniqueKey={list.user.uniqueKey} data-staf-id={list.user.id} onClick={this.resendLink} className={list.status} >Expired</span></td></tr>);
                    break
                default:
                    // do something
                    let class_name = list.status == "APPROVE" ? "activate" : list.status == "DEACTIVATED" ? "deactivate" : list.status == "ACCEPTED" ? "In Progress" : list.status;
                    let user_status = list.status == "APPROVE" ? "ACTIVE" : list.status == "DEACTIVATED" ? "INACTIVE" : list.status == "ACCEPTED" ? "PENDING" : list.status == "DECLINE" ? "REJECTED" : list.status;
                    template = (<tr key={key} className={list.status == "EXPIRED" ? "expired" : ""}><td> {list.status == "APPROVE" ? <span className="email-overflow" data-staf-id={list.user.id} onClick={this.getFacilityAdmin}>{list.user.firstName + " " + list.user.lastName}</span> : <span className="email-overflow">{list.user.firstName + " " + list.user.lastName}</span>}</td><td><span className="email-overflow">{list.user.email}</span></td><td>{list.user.mobile}</td><td><span className="email-overflow">{list.facilityRole && list.facilityRole.name ? list.facilityRole.name : 'NA'}</span></td><td><span data-staf-id={list.user.id} onClick={this.getFacilityAdmin} className={list.status == "APPROVE" ? "icon-edit" : "disabled"}></span></td><td><span data-uniqueKey={list.user.uniqueKey} data-staf-id={list.user.id} onClick={user_status == "ACTIVE" ? this.deactivate_admin : user_status == "INACTIVE" ? this.activate_admin : ""} className={class_name} > {user_status}</span></td></tr>);
                    break;
            }
            return (template)
        }, this);

        let templateStafNew = staff_arr.map(function (list, key) {

            return (<tr className={list.status == "EXPIRED" ? "expired" : ""} data-staf-id={list.user.id} key={key}><td>{list.user.guid}</td><td>{list.user.qualification && list.user.qualification.description ? list.user.qualification.description : 'NA'}</td><td>{list.facilityRole && list.facilityRole.name ? list.facilityRole.name : 'NA'}</td><td>{list.user.professionalRole && list.user.professionalRole && list.user.professionalRole.description ? list.user.professionalRole.description : 'NA'}</td><td>{list.user.gender ? list.user.gender : 'NA'}</td></tr>)
        }, this);
        templatePatient = patients.map(function (list, key) {
            return (<tr className={list.status == "EXPIRED" ? "expired" : ""} data-staf-id={list.user.id} key={key}><td>{list.user.guid}</td><td>{list.user.qualification && list.user.qualification.description ? list.user.qualification.description : 'NA'}</td> <td>{list.user.gender ? list.user.gender : 'NA'}</td></tr>)
        }, this);
        return {
            admin: templateAdmin,
            active_admin_count: active_admins.length,
            pendingOrActive_admin_count: pendingOrActive_admins.length,
            staff: templateStafNew,
            active_staff_count: active_staff.length,
            patients: templatePatient,
            active_patients_count: active_patients.length,
            isActive: _fac_detail.active,
            fac_id: _fac_detail.id,
            allAdminsCount: allAdminsCount,
            allStaffCount: allStaffCount,
            allPatientsCount: allPatientsCount,
        }
        //    console.log(admin_arr,staff_arr,patients);
    },
    handleSelect(index, last) {

    },
    deactivateFacility(event) {
        let activeStatus = event.target.dataset.isactive;
        let fac_id = event.target.dataset.fac_id;
        let msg = activeStatus == "1" ? "Are you sure you want to activate this clinic?" : "Are you sure you want to deactivate this clinic?";
        this.setState({ isActivation: true, activeStatus: activeStatus, fac_id: fac_id, modal_msg: msg });
        this.setState({ activateDeactivateCalled: true });

    },
    deactivateFacilityYes() {

        let activeStatus = this.state.activeStatus;
        let fac_id = this.state.fac_id;
        let data = fac_id + "/" + activeStatus;
        this.props.Dispatch(FacilitiesActions.deactiveFacility(data));
        this.setState({ isActivation: false, activateDeactivateCalled: true });

    },
    // AddFacilityAdmin() {
    //     this.setState({ modal_admin: true, modal_msg: "Do you want to add Admin to this clinic?" });
    // },
    AddFacilityAdmin() {
        this.props.router.push('/facilities/admin/add');
        document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
    },
    // editFacility() {
    //     this.setState({ modal: true, modal_msg: "Do you want to edit this clinic?", edit_mode: true });
    // },
    editFacility() {

        let admin = this.generateTabList();
        this.props.router.push('/edit-facilities?al=' + admin.active_admin_count + "&sl=" + admin.active_staff_count + "&pl=" + admin.active_patients_count);
        document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
    },
    // editUserLimit() {
    //     this.setState({ modal: true, modal_msg: "Do you want to change user limit?" });
    // },
    editUserLimit() {

        let admin = this.generateTabList();
        this.props.router.push('/edit-facilities?user_limit=true&al=' + admin.active_admin_count + "&sl=" + admin.active_staff_count + "&pl=" + admin.active_patients_count);
        document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
    },
    closebox() {
        this.setState({ modal_admin: false, modal: false, modal_msg: "", edit_mode: false, isActivation: false });
        this.setState({ confirmationType: null, confirmationData: null, confimationModalMessage: null, loader: false });

    },

    closeoKModalbox() {
        this.setState({ oKModalMessage: null });
    },
    render() {
        var _facilityDetails = this.getFacilityDetail();
        var staffListing = this.generateTabList();
        // console.log(staffListing.staff);
        let src = api_urls.DownloadImageURL + _facilityDetails.imageUrl + "?" + Date.now();
        let styleClear = { clear: 'both' };
        let divStyle = {

            backgroundImage: `url(${src})`

        };
        return (

            <div className="dashboard-inner-content">
                <Header loader={this.state.loader} screenIdentifier={screenIdentifier} breadcrumb={true} />
                <div className="breadcrumb-custom">
                    <h2> <a onClick={this.props.router.goBack}>CLINICS</a> >  {_facilityDetails.name}</h2>
                </div>
                <div className="admin-details">
                    <div className="row">
                        <div className="col-xs-5 no-padding">
                            <div className="admin-facility-details">
                                <div className="facility-details-holder">
                                    <h5><span className="icon icon-hospital"></span>{_facilityDetails.name}</h5>
                                    <p><span className="icon icon-map"></span>
                                        {_facilityDetails.address.street + ", " + _facilityDetails.address.city
                                            + ", " + _facilityDetails.address.state + ", " + _facilityDetails.address.zipCode + ", " + _facilityDetails.address.country}.</p>
                                    <p><span className="icon icon-phone"></span>{_facilityDetails.mobile}</p>
                                    <p><span className="icon icon-email"></span>{_facilityDetails.email}</p>
                                    <p><span className="icon icon-at"></span>{_facilityDetails.url}</p>
                                </div>
                                <div className="facility-details-values">
                                    <ul>
                                        <li>
                                            <p>Mobi Admin</p>
                                            <h5>{staffListing.active_admin_count}<span>/{_facilityDetails.maxNoOfAdmin}</span></h5>
                                        </li>
                                        <li>
                                            <p>Staff</p>
                                            <h5>{staffListing.active_staff_count}<span>/{_facilityDetails.maxNoOfStaff}</span></h5>
                                        </li>
                                        <li>
                                            <p>Patients</p>
                                            <h5>{staffListing.active_patients_count}<span>/{_facilityDetails.maxNoOfPatient}</span></h5>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="col-xs-7 no-padding">
                            <div className="admin-details-buttons pull-right">
                                <button className="edit gray-button" data-isActive={staffListing.isActive ? 0 : 1} data-fac_id={staffListing.fac_id} onClick={this.deactivateFacility} >{staffListing.isActive ? "DEACTIVATE CLINIC" : "ACTIVATE CLINIC"}</button>
                                {staffListing.isActive && staffListing.pendingOrActive_admin_count < _facilityDetails.maxNoOfAdmin ? <button className="add gray-button" onClick={this.AddFacilityAdmin} >Add Mobi Admin</button> : ""}
                                {staffListing.isActive && <button className="change gray-button" onClick={this.editUserLimit} >Change User Limit</button>}
                                {staffListing.isActive && <button className="edit gray-button" onClick={this.editFacility} >Edit Clinic</button>}
                            </div>

                            <div className="row" style={styleClear}>
                                <div className="col-xs-12 no-padding pull-right facilityDetailsimage" style={divStyle}>
                                    {false && _facilityDetails && _facilityDetails.imageUrl && _facilityDetails.imageUrl != 'false' &&
                                        <img className="facility-image pull-right" className="facility-image pull-right" width="300" height="300" src={api_urls.DownloadImageURL + _facilityDetails.imageUrl + "?" + Date.now()} />}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={staffListing.isActive ? "white-box facilities-tabs" : "white-box facilities-tabs facilities-inactive"}>
                        <Tabs onSelect={this.handleSelect} selectedIndex={0} >

                            <TabList className="nav nav-tabs">
                                <Tab className="button">Mobi Admin</Tab>
                                <Tab className="button">Staff</Tab>
                                <Tab className="button">Patients</Tab>
                            </TabList>

                            <TabPanel>
                                {staffListing.allAdminsCount ?
                                    <table className="table">
                                        <thead><tr><th>
                                            <span className="email-overflow">Mobi Admin Name</span>
                                        </th><th><span className="email-overflow">Email</span>
                                            </th><th>Phone</th><th>
                                                <span className="email-overflow">Clinic Role</span>
                                            </th><th>Edit</th><th>Status</th></tr></thead>
                                        <tbody>
                                            {staffListing.admin}
                                        </tbody>

                                    </table>
                                    : <p>No records found.</p>}
                            </TabPanel>
                            <TabPanel>
                                {staffListing.allStaffCount ?
                                    <table className="table">
                                        <thead>
                                            <tr><th>GUID</th>
                                                <th>Highest Education</th><th>Clinic Role
</th><th>Professional Role</th><th>Gender</th></tr></thead>
                                        <tbody>
                                            {staffListing.staff}
                                        </tbody>

                                    </table>
                                    : <p>No records found.</p>}
                            </TabPanel>
                            <TabPanel>
                                {staffListing.allPatientsCount ?
                                    <table className="table">
                                        <thead><tr><th>GUID</th><th>Highest Education</th><th>Gender</th></tr></thead>
                                        <tbody>
                                            {staffListing.patients}
                                        </tbody>

                                    </table>
                                    : <p>No records found.</p>}
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
                {/* <div> {this.state.modal ? <ModalDialogCommon message={this.state.modal_msg} cancel="true" action2={this.closebox} action={this.state.edit_mode ? this.editFacilityYes : this.editUserLimitYes} /> : ""}</div> */}
                {/* <div> {this.state.modal_admin ? <ModalDialogCommon message={this.state.modal_msg} cancel="true" action2={this.closebox} action={this.addFacilityAdminYes} /> : ""}</div> */}
                {this.state.oKModalMessage && <ModalDialogCommon message={this.state.oKModalMessage} action={this.closeoKModalbox} />}
                {this.state.confimationModalMessage && <ModalDialogCommon message={this.state.confimationModalMessage} cancel="true" action2={this.closebox} action={this.onConfirmed} />}
                <div> {this.state.isActivation ? <ModalDialogCommon message={this.state.modal_msg} cancel="true" action2={this.closebox} action={this.deactivateFacilityYes} /> : ""}</div>

            </div>

        );
    }
});


let mapStateToProps = (state) => {
    return {
        FacilitiesDetails: state.Facilites,
        UserDetails: state.User,
    };
};

let mapDispatchToProps = (dispatch) => ({
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(FacilitiesDetails));



/** WEBPACK FOOTER **
 ** ./src/components/facilitiesScreen/facility-details.js
 **/